import { render, staticRenderFns } from "./presionArterialGraph.vue?vue&type=template&id=a779fc06"
import script from "./presionArterialGraph.vue?vue&type=script&lang=js"
export * from "./presionArterialGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports